import { render, staticRenderFns } from "./informAuth.vue?vue&type=template&id=1ee7b3a9&"
import script from "./informAuth.vue?vue&type=script&lang=js&"
export * from "./informAuth.vue?vue&type=script&lang=js&"
import style0 from "./informAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports